/**
 * Detect aborted/cancelled HTTP requests (AbortController / axios cancel).
 * Used so callers can ignore cancel quietly without treating it as a failure.
 */
export const isRequestCancelled = (error) => {
  if (!error) return false;
  return Boolean(
    error.isCancelled ||
      error.code === "ERR_CANCELED" ||
      error.name === "CanceledError" ||
      error.name === "AbortError" ||
      error.message === "canceled" ||
      error.message === "Request cancelled" ||
      error.message === "Request aborted"
  );
};

/** Create AbortController when available (SSR / older browsers safe). */
export const createAbortController = () => {
  if (typeof AbortController === "undefined") return null;
  return new AbortController();
};

/** Abort previous controller (if any) and return a fresh one. */
export const replaceAbortController = (previousController) => {
  try {
    previousController?.abort?.();
  } catch {
    // ignore
  }
  return createAbortController();
};
